import $root from '@/proto/proto-bundle'

export const FolderService = {
  encodeUpdateFolderRequest: ({ name }) => new Promise((resolve) => {
    const requestBuilder = $root.lookup('UpdateFolderRequest')
    resolve(requestBuilder.encode({ name }).finish())
  }),
  decodeUpdateFolderResponse: ({ body }) => new Promise((resolve) => {
    const container = $root.lookup('UpdateFolderResponse')
    resolve(container.decode(new Uint8Array(body)))
  }),
  encodeCreateFolderRequest: (payload) => new Promise((resolve) => {
    const requestBuilder = $root.lookup('CreateFolderRequest')
    resolve(requestBuilder.encode(payload).finish())
  }),
  decodeCreateFolderResponse: ({ body }) => new Promise((resolve) => {
    const container = $root.lookup('CreateFolderResponse')
    resolve(container.decode(new Uint8Array(body)))
  })
}
